<script>
import ModalComponent from "@/components/Modal.vue";
import InputField from "@/components/input/InputField.vue";
import {toast} from "vue3-toastify";
import {api} from "@/modules/api";

export default {
  name: 'ModalResetPassword',
  components: {InputField, ModalComponent},
  data () {
    return {
      formData: {}
    }
  },
  methods: {
    submit () {
      api.profil.requestResetPassword(this.formData).then((res) => {
        this.$emit('closeModal', true)
        if (res.response) {
          toast.error(res.response.data.message)
        } else {
          toast(res.message)
        }
      })
    }
  }
}
</script>

<template>
  <modal-component title="Forgot your password?">
    <template #header>
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Mot de passe oublié ?
      </h3>
    </template>
    <template #body>
      <div class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
          <p class="font-light text-gray-500 dark:text-gray-400">Don't fret! Just type in your email and we will send you a code to reset your password!</p>
          <div class="mt-4 space-y-4 lg:mt-5 md:space-y-5">
            <input-field
                v-model="formData.email"
                label="Votre email"
                placeholder="example@deglingo.fr"
                type="email"
            />
            <button @click="submit" class="w-full text-white bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
              Réinitialiser mot de passe
            </button>
          </div>
      </div>
    </template>
  </modal-component>
</template>
